module.exports = __webpack_public_path__ + "img/perfil-icon.e5b8e796.svg";